import { Button, message, Modal, Upload, Form, Dropdown, Menu, Switch, Select } from 'antd';
import React from 'react';
import { api, use, app } from 'xadmin';
import { Icon } from 'xadmin-ui';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import _ from 'lodash'
import { ModelSelect } from '../../../components/ModelSelect';
import { ExtendsModel } from '../../../ui/model/components/ExtendsPage';
const { Option } = Select;

const TIPS = '保证导入的数据文字和系统中是一致的，如部门编号，带“*”的字段为必填项，请填写完整再上传，否则上传失败'
/* see Browser download file example in docs */
function s2ab(s/*:string*/)/*:ArrayBuffer*/ {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
  return buf
}
const getFieldProp = (model, field) => {
  return field.split('.').reduce((obj, f) => {
    return obj && obj.properties && obj.properties[f]
  }, model)
}
// 根据model动态生成上传参数
const findColums = (schema, prefix, columns) => {
  const properties = schema.properties || {}
  let keys = schema.form ? (
    schema.form.indexOf('*') >= 0 ?
      Object.keys(properties) : schema.form.map(f => typeof f == 'string' ? f : f.key)) :
    Object.keys(properties)

  keys = [...keys,
  ...Object.keys(properties)
    .filter(k => keys.indexOf(k) == -1 && properties[k].type == 'object')]
    .filter(k => k != 'model')

  keys.forEach(key => {
    const p = properties[key]
    if (!p) return
    if (p.type == 'object') {
      if (p.fieldType != undefined) {
        columns.push({
          title: prefix.title + p.title,
          name: prefix.name + (p.name || key),
          description: p?.description || '',
          type: p.type
        })
      } else if (p.relateTo == undefined) {
        findColums(p, { title: p.title + '-', name: prefix.name + key + '.', description: p?.description || '', }, columns)
      }
    } else if (p.type == 'array') {
      if (p.fieldType != undefined) {
        columns.push({
          title: prefix.title + p.title + (_.includes(p.name, 'custom') ? '编号' : ''), // includes检查自定义属性去除编号
          name: prefix.name + (p.name || key),
          description: p?.description || '',
          type: p.type, fieldType: p.fieldType
        })
      } else {
        columns.push({
          title: prefix.title + p.title,
          name: prefix.name + (p.name || key),
          description: p?.description || '',
          type: p.type
        })
      }
    } else {
      let description = p?.description || ''
      // 数据点标识 description 
      if (p?.title === '标识' && !p?.description) {
        description = '标识唯一，包含汉字、字母、数字、特殊字符$-_:（修改标识后会导致无法查询以旧标识存储的历史数据）'
      }
      columns.push({
        title: prefix.title + p.title,
        description,
        name: prefix.name + (p.name || key),
        type: p.type
      })
    }
  });
  return columns
}

const Uploader = ({ schema, model, selectRule }) => {
  const { modelDispatch } = use('model')
  const onUploadData = file => {
    const columns = findColums(schema, { title: '', name: '' }, [])
    return {
      columns: JSON.stringify(columns)
    }
  }
  onUploadData()
  const props = {
    name: 'file',
    accept: '.xlsx',
    action: api({ name: 'media' }).getHost() + `core/node/import/excel/${model && model.id}/${selectRule}`,
    headers: _.omit(api({ name: 'media' }).getHeaders(), 'Content-Type'),
    data: onUploadData,
    onChange(info) {
      if (info.file.status === 'done') {
        const res = info.fileList[0] && info.fileList[0].response
        if (res && res.failCount > 0 || res && res.failList.length > 0) {
          const failInfo = res.failList.map(i => i.name && i.name + `(${i.id})、`)
          const importStatus = res.failList[0] && res.failList[0].importStatus
          message.error(info.file.name + ' 文件中, ' + failInfo + importStatus);
        } else if (res && res.failCount == 0) {
          if (res.successCount > 0) {
            message.success(info.file.name + '数据导入成功！');
            setTimeout(() => modelDispatch && modelDispatch({ type: 'GET_ITEMS' }), 500)
          } else {
            message.info(`${info.file.name} 您导入的文件没有数据！`);
          }
        }
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 数据导入失败！${info?.file?.response?.message || ''}`);
      }
    }
  }

  return (
    <Upload {...props} >
      <Button disabled={!model}>
        <Icon type="upload" /> 上传 {model ? '' : <span style={{ fontSize: '12px' }}>(上传时请先选择模型)</span>}
      </Button>
    </Upload>
  )
}

const PropUploader = ({ title, schema: base, model, propName, override, index }) => {
  const { getSchema } = use('device.driver')

  const onUploadData = async file => {
    const isDevice = propName.indexOf('device') >= 0
    let deviceTags
    if (isDevice) {
      // 数据驱动模块
      const driver = model?.device?.driver
      deviceTags = await getSchema(driver, { model: true }).then(res => res?.properties?.tags?.items)
    }
    const propSchema = getFieldProp(base, propName)
    const propSchemaTtems = isDevice ? deviceTags : propSchema?.items
    if (!propSchemaTtems) {
      message.error((title || '资产属性') + '定义未找到，可能是缺少相应模块。')
      return {}
    }
    const columns = findColums(propSchemaTtems, { title: '', name: '' }, [])

    return {
      prop: propName,
      index,
      columns: JSON.stringify(columns),
      override
    }
  }

  const props = {
    name: 'file',
    accept: '.xlsx',
    action: api({ name: 'media' }).getHost() + `core/node/update/excel/prop/${model && model.id}`,
    headers: _.omit(api({ name: 'media' }).getHeaders(), 'Content-Type'),
    data: onUploadData,
    onChange(info) {
      if (info.file.status === 'done') {
        const res = info.fileList[0] && info.fileList[0].response
        if (res && res.failCount > 0 || res && res.failList.length > 0) {
          const failInfo = res.failList.map(i => i.reason).join(',')
          message.error(failInfo);
        } else if (res && res.failCount == 0) {
          if (res.successCount > 0) {
            message.success(info.file.name + '数据导入成功！');
          } else {
            message.info(`${info.file.name} 您导入的文件没有数据！`);
          }
        }
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 数据导入失败！${info?.file?.response?.message || ''}`);
      }
    }
  }

  return (
    <Upload {...props} >
      <Button disabled={!model}>
        <Icon type="upload" /> 上传 {model ? '' : <span style={{ fontSize: '12px' }}>(上传时请先选择模型)</span>}
      </Button>
    </Upload>
  )
}

const DownloadButtion = ({ schema, model }) => {

  const onDownload = () => {
    const columns = findColums(schema, { title: '', name: '' }, [])
    const ws = XLSX.utils.aoa_to_sheet([
      [{ v: TIPS, s: { fill: { fgColor: { rgb: 'FFFFAA00' } } } }],
      columns.map(c => { return c.description ? { v: c.title, t: 's', c: [{ t: c.description }] } : { v: c.title, t: 's' } })
    ])
    // 根据配置的宽度生成表格宽度
    ws['!cols'] = columns.map(col => ({ wpx: col.width ? col.width : Math.max(45, col.title.length * 15) }))
    Object.values(ws).forEach(item => {
      if (_.isObject(item) && item?.c) {
        item.c['hidden'] = true
      }
    })
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws)

    /* generate XLSX file */
    const wbout = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' })
    /* send to client */
    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${model.name}_导入模板.xlsx`)
  }


  return <Button onClick={onDownload} >下载模板</Button>
}

const DownloadPropsButtion = ({ schema: base, model, propName, title }) => {
  const { getSchema } = use('device.driver')
  const driver = model?.device?.driver

  const onDownload = async () => {

    let columns = []
    // 数据点模板导出处理 原因:有在线驱动
    if (propName == 'device.tags') {
      const tagsFields = await getSchema(driver, { model: true }).then(res => res?.properties?.tags?.items)
      if (!tagsFields) {
        message.error((title || '资产属性') + '定义未找到，可能是缺少相应模块。')
        return
      }
      columns = findColums(tagsFields, { title: '', name: '' }, [])
    } else {
      const propSchema = getFieldProp(base, propName)

      if (!propSchema || !propSchema.items) {
        message.error((title || '资产属性') + '定义未找到，可能是缺少相应模块。')
        return
      }

      // 资产导出报警规则模板去除范围限定、黑名单、白名单
      propSchema.items['properties'] = _.omit(propSchema.items?.properties, ['listType', 'whiteList', 'blackList'])
      columns = findColums(propSchema.items, { title: '', name: '' }, [])
    }
    // 报警示例
    const warningRule = ["示例报警规则", "超限报警", "低", "示例报警描述{ { nodeName } }", '{ "or": [{ "var": ["var.12331cc"] }] }',
      "是", "否", "示例数据点标识1,示例数据点标识2", "10", "10", "10", "是"]
    const exampleRows = propName == 'warning.rules' ? warningRule : []

    const ws = XLSX.utils.aoa_to_sheet([columns.map(c => { return c.description ? { v: c.title, t: 's', c: [{ t: c.description }] } : { v: c.title, t: 's' } }), [...exampleRows]])
    // 根据配置的宽度生成表格宽度
    ws['!cols'] = columns.map(col => ({ wpx: col.width ? col.width : Math.max(45, col.title.length * 15) }))
    Object.values(ws).forEach(item => {
      if (_.isObject(item) && item?.c) {
        item.c['hidden'] = true
      }
    })
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, '资产编号1')
    XLSX.utils.book_append_sheet(wb, ws, '资产编号2')

    /* generate XLSX file */
    const wbout = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' })
    /* send to client */
    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${model.name}${title}_导入模板.xlsx`)
  }

  return <Button onClick={onDownload} >下载模板</Button>
}

const UploadComponent = props => {
  const { wheres: { filters } } = use('model').modelState
  const { canAdd } = use('model.permission')
  const [visible, setVisible] = React.useState(false)
  const [propItem, setPropItem] = React.useState(null)
  const [override, setOverride] = React.useState(false)
  const [selectRule, setSelsctRule] = React.useState('false')

  const filter_model = filters && filters.model && filters.model || null
  const [model, setModel] = React.useState(filter_model)

  const handleMenuClick = e => {
    setPropItem(e.item.props.item)
    setModel(filter_model)
  }

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1" item={{ title: '驱动数据点', propName: 'device.tags', index: 'id' }}>
        导入数据点
      </Menu.Item>
      <Menu.Item key="1" item={{ title: '报警规则', propName: 'warning.rules', index: 'warningname' }}>
        导入报警规则
      </Menu.Item>
    </Menu>
  );

  //  uid 上传处理
  const convert_schema = (schema) => {
    return {
      ...schema,
      properties: {
        id: { ...schema.properties?.uid || {} },
        ..._.omit(schema.properties, ['uid']),
      },
      form: [
        { key: 'id', ...schema.form?.uid || {} },
        ...schema.form.filter(item => item && item.key != 'uid')
      ]
    }
  }
  let FgsjHelpe = (<span>选择覆盖数据会清除原有数据点后导入新数据，<br />否则新导入数据点会与原有数据点合并。</span>)
  if (propItem?.title == '报警规则') {
    FgsjHelpe = (<span>选择覆盖后规则名称重复时会清除原有数据导入新数据<br />否则导入失败</span>)
  }
  return canAdd && (
    <span>
      {
        app?.module ? <Button type="primary" onClick={() => {
          setModel(filter_model)
          setVisible(true)
        }} >导入资产</Button> : <Dropdown.Button type="primary" onClick={() => {
          setModel(filter_model)
          setVisible(true)
        }} overlay={menu}>
          导入资产
        </Dropdown.Button>
      }
      <Modal
        title="导入资产"
        destroyOnClose
        visible={visible}
        footer={null}
        afterClose={() => setModel(null)}
        onCancel={() => setVisible(false)}
      >
        <Form.Item label="模型选择"><ModelSelect value={model} width={'80%'} onChange={(v) => setModel(v)} /></Form.Item>
        {model ? <ExtendsModel name="Node" data={{ model }}>
          {schema => (<>
            <Form.Item label="数据模板" extra="请根据模板填写数据"><DownloadButtion schema={convert_schema(schema)} model={model} /></Form.Item>
            <Form.Item label="处理规则">
              <Select value={selectRule} defaultValue={'false'} style={{ width: 140 }} onChange={(value) => setSelsctRule(value)}>
                <Option value="false">报错提示并跳过</Option>
                <Option value="true">覆盖更新</Option>
              </Select>
            </Form.Item>
            <Form.Item label="上传文件"><Uploader schema={convert_schema(schema)} selectRule={selectRule} model={model} /></Form.Item>
          </>)}
        </ExtendsModel> : null}
      </Modal>
      <Modal
        title={'导入' + (propItem && propItem.title || '资产属性')}
        footer={null}
        visible={propItem != null}
        destroyOnClose
        afterClose={() => setModel(null)}
        onOk={() => setPropItem(null)}
        onCancel={() => setPropItem(null)}
      >
        <Form.Item label="模型选择"><ModelSelect value={model} width={'80%'} onChange={(v) => setModel(v)} /></Form.Item>
        {model && propItem ? <ExtendsModel name="Node" data={{ model }}>
          {schema => (<>
            <Form.Item label="数据模板" help={<span>请根据模板填写数据，Excel中每个资产的数据放在<br />单独的sheet中，sheet名为资产编号。</span>}>
              <DownloadPropsButtion schema={convert_schema(schema)} model={model} {...propItem} /></Form.Item>
            <Form.Item label="覆盖数据" help={FgsjHelpe}>
              <Switch checked={override} onChange={setOverride} /></Form.Item>
            <Form.Item label="上传文件">
              <PropUploader schema={convert_schema(schema)} model={model} override={override} {...propItem} />
            </Form.Item>

          </>)}
        </ExtendsModel> : null}
      </Modal>
    </span>
  )
}

export default UploadComponent
